<div class="setting-page">
  <div class="cac-profiles">
    <legend>CAC Profiles</legend>
    <div class="action-buttons">
      <arm-action-bar (addClick)="addCacProfile()" [disableAdd]="isUnauthorized"
                      (refreshClick)="refresh()"
                      (deleteClick)="deleteCacProfile()" [disableDelete]="isUnauthorized || !selection"
                      (editClick)="editCacProfile()" [disableEdit]="isUnauthorized || !selection">
      </arm-action-bar>
    </div>

    <div class="cac-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" (pageChanged)="pageChanged($event)"
                 [data]="data.elements" [length]="data.totalElements"
                 [isMultipleSelection]="false"
                 [isClientSide]="false"></arm-table>
    </div>
  </div>
  <cac-profiles-configuration [isUnauthorized]="isUnauthorized"></cac-profiles-configuration>
</div>
